import { useRef, useState, useEffect} from "react";
import SelectPicker from 'rsuite/SelectPicker';
import 'rsuite/SelectPicker/styles/index.css';
import {axiosInstance} from "../helpers/axiosInstance";

/**
 * COMPONENTE PRINCIPAL
 * @param formik
 * @returns {JSX.Element}
 * @constructor
 */
export default function Cajas({
  formik,
}){
    /**
     * Arreglo de cajas
     */
    const [data, setData] = useState([]);
    /**
     * Para que el SelectPicker se despliegue correctamente en una ventana modal
     * necesita un contenedor
     * @type {React.MutableRefObject<null>}
     */
    const cajaRef = useRef(null);
    /**
     * Datos del catálogo : Cajas
     */
    const { setFieldValue } = formik;

     useEffect(() => {
         const { cajas } = JSON.parse(sessionStorage.getItem('user')) ?? [];

         let array = [];
         cajas && cajas.forEach(
             /**
              * Solo cajas para pagos en efectivo
              * @param item.tipo
              * @param item.id_caja
              * @param item.caja
              */
             (item) => {
                 if (item.tipo === "C") {
                     array.push({valor: item.id_caja, descripcion: item.caja});
                 }
             }
         );

         /**
          * Solo se agregan los valores sí el usuario tiene cajas disponibles
          */
         if (array.length > 0) {
             setData(array);
         } else {
             setFieldValue('id_caja', "");
         }
    },[setFieldValue]);

    return(
        <>
            <style type={'text/css'}>
                {`
                    #id_caja{
                        background-color : var(--bs-gray-100)!important;
                        border: 0!important;
                    }
                    
                    #id_caja > .rs-stack{
                        display : block!important;
                    }                      
                    #id_caja-label{
                        display : flex!important;
                    }
                    .labelSelect {
                        font-size : 1rem;
                        color: rgba(var(--bs-body-color-rgb),.65);
                        transform: scale(.85) translateY(-.5rem) translateX(.15rem);
                        position : absolute;
                        left : 0;
                    }
                    #id_caja > .rs-stack > div:nth-child(2){
                        padding-top : 1.25rem;
                        text-transform:uppercase!important;
                    }
                    
                    #id_caja-listbox > div > span.rs-picker-select-menu-item-active{
                        color : var(--bs-component-hover-color);
                    }
                    
                    #id_caja-listbox > div > span.rs-picker-select-menu-item-active::after{
                        background-color: var(--bs-component-hover-color);
                        content: "";
                        display: block;
                        height: .75rem;
                        -webkit-mask-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 11'%3E%3Cpath fill='var(--bs-component-hover-color)' d='M4.896 6.498 2.795 4.265A1.33 1.33 0 0 0 .857 6.088l3.893 4.138a1 1 0 0 0 1.457 0l6.936-7.373a1.33 1.33 0 0 0-1.938-1.823L6.061 6.498a.8.8 0 0 1-1.165 0'/%3E%3C/svg%3E");
                        mask-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 11'%3E%3Cpath fill='var(--bs-component-hover-color)' d='M4.896 6.498 2.795 4.265A1.33 1.33 0 0 0 .857 6.088l3.893 4.138a1 1 0 0 0 1.457 0l6.936-7.373a1.33 1.33 0 0 0-1.938-1.823L6.061 6.498a.8.8 0 0 1-1.165 0'/%3E%3C/svg%3E");
                        mask-position: center;
                        -webkit-mask-position: center;
                        mask-repeat: no-repeat;
                        -webkit-mask-repeat: no-repeat;
                        width: .75rem;
                    }
                    
                    #id_caja-listbox > div > span.rs-picker-select-menu-item{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        text-transform:uppercase!important;
                    }
                    .rs-picker-toggle-label::after {
                        display : none!important;
                    }
                    
                `}
            </style>
            <div ref={cajaRef} className={'position-relative'}>
                <SelectPicker
                    container={() => cajaRef.current}
                    label={<div className={'labelSelect ps-2'}>Caja:</div>}
                    data={data}
                    style={{width: "100%"}}
                    menuStyle={{width: '100%'}}
                    menuAutoWidth={false}
                    id={'id_caja'}
                    name={'id_caja'}
                    labelKey={'descripcion'}
                    valueKey={'valor'}
                    value={formik.values.id_caja}
                    onChange={(value) => setFieldValue('id_caja', value)}
                    onBlur={formik.handleBlur}
                    searchable={false}
                    cleanable={false}
                    disabled={data.length === 0}
                />
            </div>
        </>
    );
}

/**
 *
 * @param formik
 * @returns {JSX.Element}
 * @constructor
 */
export function CajasDestino({formik}){
    /**
     * Arreglo de cajas
     */
    const [cajas, setCajas] = useState([]);

    /**
     * Se guardan todas las cajas disponibles para el usuario
     */
    useEffect(() => {
        const cajasLS = JSON.parse(localStorage.getItem('cajasDestino')) ?? [];

        if (cajasLS.length > 0) {
            setCajas(cajasLS);
        }else {
            axiosInstance.get('/cajas').then((response) => {
                setCajas(response.data);
                localStorage.setItem('cajasDestino', JSON.stringify(response.data));
            }).catch((error) => {
                setCajas([
                    {
                        id_caja : "notFound",
                        caja : 'Sin resultados'
                    }
                ]);
                console.log(error);
            });
        }
    },[]);

    return(
        <>
            <style type={'text/css'}>
                {`
                    #id_caja_destino{
                        background-color : var(--bs-gray-100)!important;
                        border: 0!important;
                    }
                    
                    #id_caja_destino > .rs-stack{
                        display : block!important;
                    }                      
                    #id_caja_destino-label{
                        display : flex!important;
                    }
                    .labelSelect {
                        font-size : 1rem;
                        color: rgba(var(--bs-body-color-rgb),.65);
                        transform: scale(.85) translateY(-.5rem) translateX(.15rem);
                        position : absolute;
                        left : 0;
                    }
                    #id_caja_destino > .rs-stack > div:nth-child(2){
                        padding-top : 1.25rem;
                        text-transform:uppercase!important;
                    }
                    
                    #id_caja_destino-listbox > div > span.rs-picker-select-menu-item-active{
                        color : var(--bs-component-hover-color);
                    }
                    
                    #id_caja_destino-listbox > div > span.rs-picker-select-menu-item-active::after{
                        background-color: var(--bs-component-hover-color);
                        content: "";
                        display: block;
                        height: .75rem;
                        -webkit-mask-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 11'%3E%3Cpath fill='var(--bs-component-hover-color)' d='M4.896 6.498 2.795 4.265A1.33 1.33 0 0 0 .857 6.088l3.893 4.138a1 1 0 0 0 1.457 0l6.936-7.373a1.33 1.33 0 0 0-1.938-1.823L6.061 6.498a.8.8 0 0 1-1.165 0'/%3E%3C/svg%3E");
                        mask-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 11'%3E%3Cpath fill='var(--bs-component-hover-color)' d='M4.896 6.498 2.795 4.265A1.33 1.33 0 0 0 .857 6.088l3.893 4.138a1 1 0 0 0 1.457 0l6.936-7.373a1.33 1.33 0 0 0-1.938-1.823L6.061 6.498a.8.8 0 0 1-1.165 0'/%3E%3C/svg%3E");
                        mask-position: center;
                        -webkit-mask-position: center;
                        mask-repeat: no-repeat;
                        -webkit-mask-repeat: no-repeat;
                        width: .75rem;
                    }
                    
                    #id_caja_destino-listbox > div > span.rs-picker-select-menu-item{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        text-transform:uppercase!important;
                    }
                    .rs-picker-toggle-label::after {
                        display : none!important;
                    }
                    
                `}
            </style>
            <SelectPicker
                label={<div className={'labelSelect ps-2'}>Caja destino:</div>}
                data={cajas}
                style={{width: "100%"}}
                menuStyle={{width: 'auto'}}
                id={'id_caja_destino'}
                name={'id_caja_destino'}
                labelKey={'caja'}
                valueKey={'id_caja'}
                value={formik.values.id_caja_destino}
                onChange={(value) => formik.setFieldValue('id_caja_destino', value)}
                onBlur={formik.handleBlur}
                searchable={false}
                cleanable={false}
                disabledItemValues={["notFound"]}
            />
        </>
    );
}


export function CajasCompletas({formik}){
    /**
     * Arreglo de datos
     */
    const [data, setData] = useState([]);
    /**
     * Senecesita un contenedor para el SelectPicker cuando se renderiza en ventana modal
     * @type {React.MutableRefObject<null>}
     */
    const cajaTablaRef = useRef(null);
    /**
     * Datos del catálogo : Cajas
     */
    const { setFieldValue } = formik;

    useEffect(() => {
        const { cajas } = JSON.parse(sessionStorage.getItem('user')) ?? [];

        if (cajas.length > 0) {
            setData(cajas);
        } else {
            setFieldValue('caja', "");
        }
    },[setFieldValue]);

    return(
        <>
            <style type={'text/css'}>
                {`
                    #caja_tabla{
                        background-color : var(--bs-gray-100)!important;
                        border: 0!important;
                    }
                    
                    #caja_tabla > .rs-stack{
                        display : block!important;
                    }                      
                    #caja_tabla-label{
                        display : flex!important;
                    }
                    .labelSelect {
                        font-size : 1rem;
                        color: rgba(var(--bs-body-color-rgb),.65);
                        transform: scale(.85) translateY(-.5rem) translateX(.15rem);
                        position : absolute;
                        left : 0;
                    }
                    #caja_tabla > .rs-stack > div:nth-child(2){
                        padding-top : 1.25rem;
                        text-transform:uppercase!important;
                    }
                    
                    #caja_tabla-listbox > div > span.rs-picker-select-menu-item-active{
                        color : var(--bs-component-hover-color);
                    }
                    
                    #caja_tabla-listbox > div > span.rs-picker-select-menu-item-active::after{
                        background-color: var(--bs-component-hover-color);
                        content: "";
                        display: block;
                        height: .75rem;
                        -webkit-mask-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 11'%3E%3Cpath fill='var(--bs-component-hover-color)' d='M4.896 6.498 2.795 4.265A1.33 1.33 0 0 0 .857 6.088l3.893 4.138a1 1 0 0 0 1.457 0l6.936-7.373a1.33 1.33 0 0 0-1.938-1.823L6.061 6.498a.8.8 0 0 1-1.165 0'/%3E%3C/svg%3E");
                        mask-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 11'%3E%3Cpath fill='var(--bs-component-hover-color)' d='M4.896 6.498 2.795 4.265A1.33 1.33 0 0 0 .857 6.088l3.893 4.138a1 1 0 0 0 1.457 0l6.936-7.373a1.33 1.33 0 0 0-1.938-1.823L6.061 6.498a.8.8 0 0 1-1.165 0'/%3E%3C/svg%3E");
                        mask-position: center;
                        -webkit-mask-position: center;
                        mask-repeat: no-repeat;
                        -webkit-mask-repeat: no-repeat;
                        width: .75rem;
                    }
                    
                    #caja_tabla-listbox > div > span.rs-picker-select-menu-item{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        text-transform:uppercase!important;
                    }
                    .rs-picker-toggle-label::after {
                        display : none!important;
                    }
                    
                `}
            </style>
            <div ref={cajaTablaRef} className={'position-relative'}>
                <SelectPicker
                    container={() => cajaTablaRef.current}
                    label={<div className={'labelSelect ps-2'}>Caja:</div>}
                    data={data}
                    style={{width: "100%"}}
                    menuStyle={{width: '100%'}}
                    id={'caja_tabla'}
                    name={'caja_tabla'}
                    labelKey={'caja'}
                    valueKey={'id_caja'}
                    value={formik.values.caja_tabla}
                    onChange={(value) => setFieldValue('caja_tabla', value)}
                    onBlur={formik.handleBlur}
                    searchable={false}
                    cleanable={false}
                    disabled={data.length === 0}
                />
            </div>
        </>
    );
}
